const swagger = {
    invalid_zod_type: 'Nieprawidłowy typ Zod. Sprawdź konfigurację straży routy.',
    not_supported_zod_type_for_params: 'Nieobsługiwany typ Zod dla parametrów. Sprawdź konfigurację straży routy.',
};
export default swagger;
